import React from "react";
import { BlockKey, BlockScore, PhaseKey } from "../../types";
import styles from "./BlockGrid.module.css";

const LABELS: Record<BlockKey, string> = {
  trustedPartner: "TRUSTED PARTNER",
  engage: "ENGAGE",
  discover: "DISCOVER",
  buildValue: "BUILD VALUE",
  advance: "ADVANCE",
};

const COLOR_VAR: Record<BlockKey, string> = {
  trustedPartner: "var(--color-brand-red)",
  engage: "var(--color-block-engage)",
  discover: "var(--color-block-discover)",
  buildValue: "var(--color-block-build-value)",
  advance: "var(--color-block-advance)",
};

interface BlockTileProps {
  block: BlockScore;
}

function BlockTile({ block }: BlockTileProps) {
  const color = COLOR_VAR[block.key];
  return (
    <div
      className={styles.tile}
      style={{ borderTopColor: color }}
    >
      <div className={styles.tileHeader}>
        <span className={styles.tileLabel}>{LABELS[block.key]}</span>
        <span className={styles.tileWeight}>{block.weight > 0 ? `${block.weight}%` : "context"}</span>
      </div>
      <span className={styles.tileScore} style={{ color }}>
        {block.score}
      </span>
      <div className={styles.tileBar}>
        <div
          className={styles.tileBarFill}
          style={{ width: `${block.score}%`, background: color }}
        />
      </div>
      <p className={styles.tileSummary}>{block.summary}</p>
    </div>
  );
}

interface BlockGridProps {
  blocks: BlockScore[];
  selectedBlock: PhaseKey;
  trustedPartner: BlockScore;
}

export default function BlockGrid({ blocks, selectedBlock, trustedPartner }: BlockGridProps) {
  const selected = blocks.find((b) => b.key === selectedBlock);

  return (
    <div className={styles.grid}>
      <BlockTile block={trustedPartner} />
      {selected && <BlockTile block={selected} />}
    </div>
  );
}
